'use strict';

export default class {
	/*@ngInject*/
	constructor($http, $filter, $scope, JSONToCSVConvertor, HourFinder, ColorFinder, ValidIndexes) {
		this.$http = $http;
		this.$filter = $filter;
		this.$scope = $scope;
		this.search = {};
		this.JSONToCSVConvertor = JSONToCSVConvertor;
		this.HourFinder = HourFinder;
		this.ColorFinder = ColorFinder;
		this.ValidIndexes = ValidIndexes;
		this.results = []; // [{}, {}]
	}

	$onInit() {
		this.colors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple', 'orange', 'dark orange', 'lime', 'dark lime'];

		this.$scope.getStyle = function(crmID, role) {
			if((crmID === undefined || crmID === '') && role === 'tutor') {
				return {color: 'red'};
			}
			if((crmID === undefined || crmID === '' || crmID.includes('-') === false) && role === 'student' && parseInt(crmID, 10) !== 0) {
				return {color: 'blue'};
			}
		};

		this.$http.get('/api/tutors')
			.then(response => {
				this.tutors = response.data;
			});

		this.loadCal(new Date()); // load Lessons data
		this.$http.get('/api/lessons/time', {params: {monthLists: JSON.stringify(this.monthLists)}})
			.then(response => {
				this.lessons = response.data;
			});

		this.$http.get('/api/students')
			.then(response => {
				this.students = response.data;
			});
	}

	export(data, endDate) {
		endDate = this.$filter('date')(endDate, 'dd/MM/yyyy');
		data = data.map(entity => (
			{
				tutorName: entity.tutorFullName,
				clientName: entity.student.fullName,
				time: entity.totalTime,
			}
		));
		data.push({ clientName: 'Total Time', time: this.totalTime });
		this.JSONToCSVConvertor(data, `Tutor-Export-Timesheet-${endDate}`, true);
	}

	loadCal(day) {
		this.monthLists = {};
		for(var i = 0; i <= 1; i++) {
			var localeToday = new Date();
			localeToday.setMonth(day.getMonth() - i);
			localeToday = localeToday.toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit', day: '2-digit' });
			var month = localeToday.split('/')[1];
			var year = localeToday.split('/')[2];
			if(!(year in this.monthLists)) {
				this.monthLists[year] = [];
			}
			this.monthLists[year].push(month);
		}
	}

	returnFilter(results, $query) {
		return results.filter(function(item) {
			return item.fullName.toLowerCase().indexOf($query.toLowerCase()) != -1;
		});
	}

	submit() {
		this.$scope.success = false;
		this.$scope.error = null;
		this.results = [];
		var { start, end, tutor } = this.search;
		if(!start || !end) {
			return;
		}
		if(!tutor) {
			tutor = this.tutors;
		}
		this.loadCal(end);
		this.$http.get('/api/lessons/time', {params: {monthLists: JSON.stringify(this.monthLists)}}).then(response => {
			this.lessons = response.data;
			this.less = [];
			this.totalTime = 0;

			tutor.forEach(tut => {
				this.results = [];
				const tutorsLessons = this.lessons.filter(entity => entity.tutorUID === tut._id);
				tutorsLessons.forEach(entity => this.timeCompress(entity, start, end));

				this.results = this.results.sort((a, b) => {
					if(a.student.fullName < b.student.fullName) return -1;
					if(a.student.fullName > b.student.fullName) return 1;
					return 0;
				});

				this.results.forEach(ent => {
					this.totalTime += ent.totalTime;
					ent.tutorFullName = tut.fullName;
					ent.tutorCrmID = tut.crmID;
					this.less.push(ent);
				});
			});
		});
	}

	checkDate(startDate, endDate) {
		startDate = startDate.split('/');
		var start = new Date(startDate[2], startDate[1] - 1, startDate[0]);
		endDate = endDate.split('/');
		var end = new Date(endDate[2], endDate[1] - 1, endDate[0]);
		var diffDays = Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24));
		return end.getDay() === 0 && diffDays === 6;
	}

	timeCompress(lesson, start, end) {
		lesson.student = this.students.find(student => lesson.clientUID == student._id);

		const validIndexes = this.ValidIndexes(lesson, start, end);
		validIndexes.forEach(index => {
			const effectiveColor = this.ColorFinder(lesson, index); //effective being the actual colour of the sessions
			if(!this.colors.includes(effectiveColor)) {
				return;
			}

			var student = {
				first: lesson.student.firstName,
				last: lesson.student.lastName,
				fullName: lesson.student.fullName,
				crmID: lesson.student.crmID,
				_id: lesson.student._id,
			};

			if(lesson.overwriteName && lesson.overwriteName[index]) {
				student.first = lesson.overwriteName[index];
				student.last = null;
				student.fullName = `${lesson.overwriteName[index]} - Overwritten Name`;
			}

			this.addToResults({
				student,
				totalTime: this.HourFinder(lesson, index) / 60,
			});
		});
	}

	addToResults(data) {
		const foundIndex = this.results.findIndex(result => result.student.fullName === data.student.fullName);

		if(foundIndex === -1) {
			return this.results.push(data);
		}

		this.results[foundIndex].totalTime += data.totalTime;
	}

	processData(data, locations) {
		this.studentCRMs = {}; // contain Student objects with key CRM-ID
		this.tutorHours = {}; // Teaching Hours of Tutors for each Student
		data.forEach(entity => {
			var tutorCrmID = entity.tutorCrmID; // Tutor CRM-ID
			var studentCrmID = entity.student.crmID; // Student CRM-ID
			if(!(tutorCrmID in this.tutorHours)) {
				this.tutorHours[tutorCrmID] = {};
			}
			if(!(studentCrmID in this.studentCRMs)) {
				this.studentCRMs[studentCrmID] = {};
			}
			var name = `${entity.student.first} ${entity.student.last}`;
			this.studentCRMs[studentCrmID].fullName = name;
			this.studentCRMs[studentCrmID].location = locations[entity.student._id];
			if(!(studentCrmID in this.tutorHours[tutorCrmID])) {
				this.tutorHours[tutorCrmID][studentCrmID] = {};
				this.tutorHours[tutorCrmID][studentCrmID].hours = 0;
			}
			this.tutorHours[tutorCrmID][studentCrmID].hours = this.tutorHours[tutorCrmID][studentCrmID].hours + entity.totalTime;
		});
	}

	exportTimeSheet(data, tutor, startDate, endDate) {
		if(tutor === null || tutor === undefined) {
			const tutorIDs = data.map(lesson => lesson.tutorCrmID);
			tutor = this.tutors.filter(function(t) {
				return tutorIDs.includes(t.crmID);
			});
		}
		startDate = this.$filter('date')(startDate, 'dd/MM/yyyy');
		if(parseInt(startDate.charAt(0), 10) === 0) {
			startDate = startDate.substring(1);
		}
		endDate = this.$filter('date')(endDate, 'dd/MM/yyyy');
		let dayEnd = endDate.split('/')[0];
		let monthEnd = endDate.split('/')[1];
		if(parseInt(dayEnd.charAt(0), 10) === 0) {
			dayEnd = dayEnd.substring(1);
		}
		if(parseInt(monthEnd.charAt(0), 10) === 0) {
			monthEnd = monthEnd.substring(1);
		}
		endDate = `${dayEnd}/${monthEnd}/${endDate.split('/')[2]}`;
		let validationTutor = tutor.some(tut => tut.crmID === '' || tut.crmID === undefined);
		let validationStudent = data.some(entity => (entity.student.crmID === '' || entity.student.crmID === undefined
			|| entity.student.crmID.includes('-') === false) && parseInt(entity.student.crmID, 10) !== 0);
		// Checking the CRM-ID field and the Date field
		if(validationTutor || validationStudent) {
			this.$scope.error = 'Tutor has an empty crmID field or Student has wrong crmID format. Please check again!';
			this.$scope.success = false;
		} else if(this.checkDate(startDate, endDate) !== true) {
			this.$scope.error = 'End Date must be Sunday and Start Date must be Monday before that!';
			this.$scope.success = false;
		} else {
			this.$http.post('/api/lessons/student-info', {data: JSON.stringify(data)})
			.then(info => {
				if(info.status !== 200) {
					this.$scope.error = 'Error processing. Try again!';
				} else {
					let studentLocations = {};
					info.data.forEach(student => {
						// Get the first uppercase character of Student's location
						studentLocations[student[0].clientUID] = student[0].location.toUpperCase().charAt(0);
					});
					this.processData(data, studentLocations);

					this.$http.get('/api/tutors/crm-id/', {params: {ids: Object.keys(this.tutorHours)}})
					.then(res => {
						let foundIDs = res.data.map(x => x.crmID);
						let wrongIDs = Object.keys(this.tutorHours).filter(e => foundIDs.indexOf(e) === -1);
						console.log('Wrong tutor IDs');
						console.log(wrongIDs);
						if(res.status != 200) {
							this.$scope.error = 'Error adding data to timesheet. Please try again!';
							this.$scope.success = false;
						} else if(wrongIDs.length > 0) {
							this.$scope.error = `The Tutor CRM IDs ${wrongIDs.join(', ')} do not exist in Sheets app`;
							this.$scope.success = false;
						} else {
							let tutorIDs = {};
							for(let i = 0; i < res.data.length; i++) {
								tutorIDs[res.data[i].crmID] = res.data[i].tutorID;
							}
							this.$http.post('/api/tutors/addTimeSheet', { tutorIDs, tutorHours: this.tutorHours, studentCRMs: this.studentCRMs, weekEnding: endDate})
							.then(innerRes => {
								if(innerRes.status == 200) {
									this.$scope.success = true;
									this.$scope.error = null;
								} else {
									this.$scope.error = 'Error adding data to timesheet. Please try again!';
									this.$scope.success = false;
							}});
						}
					});
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./client/app/admin/export-tutor/export-tutor.controller.js